import React from 'react'
import { Switch } from 'react-router-dom'

import ForgotPassword from '../pages/ForgotPassword'
import Home from '../pages/Home'
import Login from '../pages/SignIn'
import SignUp from '../pages/SignUp'

import Route from './Route'

const Routes: React.FC = () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/signin" exact component={Login} />
    <Route path="/signup" exact component={SignUp} />
    <Route path="/reset-password" exact component={ForgotPassword} />
  </Switch>
)

export default Routes
